// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyCapnuQQEBpPdlgoo6Cb2x-9wAwiV9RRRc",
  authDomain: "chatxapp-de93b.firebaseapp.com",
  databaseURL: "https://chatxapp-de93b-default-rtdb.firebaseio.com",
  projectId: "chatxapp-de93b",
  storageBucket: "chatxapp-de93b.appspot.com",
  messagingSenderId: "376938923729",
  appId: "1:376938923729:web:4a69c065826a6a2a14e7f0",
  measurementId: "G-728S9XC2S4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();